import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { PartnerApi, PartnerDTO } from '@lkp/parking-sdk';
import { delay, Subject, takeUntil } from 'rxjs';
import { SetCurrentPartner } from 'src/app/core/states/partner/partner.action';
import { Inject } from '@angular/core';
import { PARTNER_API } from '../../core/providers/api.module';

@Component({
    selector: 'app-navbar-admin',
    templateUrl: './navbar-admin.component.html',
    styleUrls: ['./navbar-admin.component.scss'],
    standalone: false
})
export class NavbarAdminComponent {
  partners?: PartnerDTO[];
  partnerIsActiveNow = false; // Can't user routerLinkActive in the partner menu. This is a workaround.
  readonly onDestroy$ = new Subject<void>();

  constructor(
    @Inject(PARTNER_API) readonly partnerApi: PartnerApi,
    readonly store: Store,
    readonly router: Router
  ) {}

  ngOnInit() {
    this.partnerApi
      .findPartners()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((partners) => {
        this.partners = partners;
      });
  }

  setCurrentPartner(partner: PartnerDTO) {
    partner &&
      this.store
        .dispatch(new SetCurrentPartner(partner))
        .pipe(takeUntil(this.onDestroy$), delay(0))
        .subscribe(() => {
          this.router.navigate(['/partnerportalen/']);
        });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
